(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9192],{

/***/ 16126:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicine-dictionary/[id]",
      function () {
        return __webpack_require__(59071);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
// PageDescription: 의약품 정보 상세 페이지 리다이렉트
// 이 페이지는 렌더링되지 않고 항상 리다이렉트됩니다
var MedicineDictionaryRedirectPage = function() {
    return null;
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (MedicineDictionaryRedirectPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(16126); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);